const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWeInnovate(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 500 500",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "freepik--background-complete--inject-45"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 62.77,
    y: 376.37,
    width: 35.16,
    height: 11.19,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 380.9,
    y: 270.18,
    width: 35.16,
    height: 11.19,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.32,401.67c-5.86.1-20.63.35-26.29.42l-8.87,0h-.45v-.46l0-11.19V390h.5l17.58.07c4.37,0,13.2.14,17.58.2h.24v.23l-.23,11.19Zm0,0-.24-11.19.24.24c-4.39.06-13.2.16-17.58.2L43.16,391l.5-.5,0,11.19-.46-.45,8.71,0c5.57.07,20.68.32,26.45.41Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M193.5,188.82c-5.86.1-20.63.35-26.29.42l-8.87,0h-.45v-.46l0-11.19v-.5h.5l17.58.06c4.38,0,13.2.14,17.58.2h.24v.23l-.24,11.19Zm0,0-.24-11.19.24.24c-4.39.06-13.19.16-17.58.2l-17.58.06.5-.5,0,11.19-.46-.45,8.71,0c5.58.07,20.69.32,26.45.41Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M173.89,202.93c-5.86.1-20.63.35-26.29.42l-8.87,0h-.45v-.46l-.05-11.19v-.5h.5l17.58.06c4.38,0,13.2.14,17.58.2h.24v.23l-.24,11.19Zm0,0-.24-11.19.24.24c-4.39.06-13.2.16-17.58.2l-17.58.06.5-.5,0,11.19-.46-.45,8.71,0c5.57.07,20.68.32,26.45.41Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 119.2,
    y: 177.63,
    width: 35.16,
    height: 11.19,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 421.68,
    y: 390.48,
    width: 35.16,
    height: 11.19,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 402.07,
    y: 44.93,
    width: 35.16,
    height: 11.19,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M456.84,70.23c-5.86.1-20.63.35-26.29.42l-8.87,0h-.45v-.46L421.18,59v-.5h.5l17.58.07c4.38,0,13.2.13,17.58.2h.24V59l-.24,11.19Zm0,0L456.6,59l.24.24c-4.39.06-13.19.16-17.58.19l-17.58.07.5-.5,0,11.19-.46-.45,8.71,0c5.58.06,20.69.32,26.45.41Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.93,56.12c-5.86.1-20.63.35-26.29.42l-8.87,0h-.45v-.46l0-11.19v-.5h.5l17.58.07c4.38,0,13.2.13,17.58.2h.24v.23l-.24,11.19Zm0,0-.24-11.19.24.24c-4.39.06-13.2.16-17.58.19l-17.58.07.5-.5,0,11.19-.46-.45,8.71,0c5.57.06,20.68.32,26.45.41Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 40.29,
    y: 266.85,
    width: 146.12,
    height: 8.92,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 53.32,
    y: 275.77,
    width: 120.06,
    height: 24.61,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "173.38 280.64 53.32 283.02 53.32 275.77 173.38 275.77 173.38 280.64",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M155.29,295.74H71.41V280.43h83.88Zm-82.88-1h81.88V281.43H72.41Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 99.69,
    y: 286.02,
    width: 27.33,
    height: 4.13,
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "52.35 441.94 48.37 441.94 59.94 300.39 70.08 300.39 52.35 441.94",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "70.08 300.39 68.89 309.86 59.17 309.86 59.94 300.39 70.08 300.39",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "174.35 441.94 178.33 441.94 166.76 300.39 156.62 300.39 174.35 441.94",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "156.62 300.39 157.81 309.86 167.53 309.86 166.76 300.39 156.62 300.39",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "freepik--xsrjP0--inject-45"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M407.64,208c-1.2-1.15-2.14-2.66-4-2.87-.73-.08-.45-.64-.37-1q2.16-10.44,4.33-20.87c.11-.51.22-.92.83-1.08,5.87-1.57,9.27-6.36,13.47-10.19a21.24,21.24,0,0,0,7.14-15c.1-1.61,1-2.16,2.45-2.19,1.78,0,3.37.79,3.71,2.08a28.76,28.76,0,0,1,1.14,9.75c-.24,2.7-1.73,5.07-2.6,7.61-.64,1.86-1.48,3.66-2.24,5.51.39.44,1,.38,1.47.49l17.63,3.68c2.47.51,3.54,1.47,3.54,3.19a4.81,4.81,0,0,1-3.62,4.56c-.49.13-1.24-.23-1.44.44s.64.79,1,1.16c1.82,1.9.8,4.83-2,6.05-.67.3-1.78-.13-2,.73-.16.69.92.9,1.3,1.49,1.36,2.06-.15,5-3,5.79a8.18,8.18,0,0,0-1.12.19c-.33.13-.66.29-.18.81,2.17,2.35,1.59,4.87-1.36,6.18l-.88.39a5,5,0,0,1-3.23,0q-13.83-2.85-27.65-5.75A3.34,3.34,0,0,1,407.64,208Z",
    style: {
      fill: "#ebebeb",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M384,190.23c.92-4.42,1.86-8.84,2.75-13.26.18-.9.36-1.32,1.46-1.08q8.07,1.79,16.17,3.37c1.06.21,1.14.61.94,1.54q-2.82,13.33-5.55,26.69c-.23,1.13-.6,1.38-1.73,1.13-5.22-1.15-10.45-2.25-15.69-3.26-1.3-.25-1.39-.74-1.14-1.88C382.19,199.08,383.07,194.65,384,190.23Z",
    style: {
      fill: "#ebebeb",
      fillRule: "evenodd"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 85.69,
    width: 1,
    height: 113.71,
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "123.75 149.91 120.73 156.55 51.65 156.55 48.63 149.91 78.05 129.56 94.34 129.56 123.75 149.91",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "96.38 109.94 94.34 129.56 78.05 129.56 76 109.94 96.38 109.94",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "123.75 149.91 120.73 156.56 51.64 156.56 48.63 149.91 123.75 149.91",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 155.44,
    width: 1,
    height: 64.29,
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "193.5 100.49 190.48 107.13 121.39 107.13 118.38 100.49 147.79 80.13 164.09 80.13 193.5 100.49",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "166.13 60.52 164.09 80.13 147.79 80.13 145.75 60.52 166.13 60.52",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "193.5 100.49 190.48 107.13 121.39 107.13 118.38 100.49 193.5 100.49",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 266.17,
    y: 123.73,
    width: 53.08,
    height: 53.08,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M322,121H263.41v58.6H322Zm-55.85,55.84V123.73h53.09v53.08Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 276.45,
    y: 131.62,
    width: 18.35,
    height: 41.37,
    transform: "translate(571.26 304.61) rotate(180)",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 282.12,
    y: 139.67,
    width: 21.2,
    height: 21.2,
    transform: "translate(585.43 300.54) rotate(180)",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 291.58,
    y: 151.4,
    width: 2.26,
    height: 58.61,
    transform: "translate(473.42 -112.01) rotate(90)",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 266.17,
    y: 49.01,
    width: 53.08,
    height: 53.08,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 270.72,
    y: 58.14,
    width: 40.04,
    height: 13.86,
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M322,46.25H263.41v58.61H322ZM266.17,102.1V49h53.09V102.1Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 282.12,
    y: 64.96,
    width: 21.2,
    height: 21.2,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 291.58,
    y: 76.69,
    width: 2.26,
    height: 58.61,
    transform: "translate(398.71 -186.72) rotate(90)",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 266.17,
    y: 199.97,
    width: 53.08,
    height: 53.08,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 294.61,
    y: 205.86,
    width: 17.41,
    height: 29.13,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M322,197.21H263.41v58.6H322Zm-55.85,55.84V200h53.09v53.08Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 282.12,
    y: 215.91,
    width: 21.2,
    height: 21.2,
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 291.58,
    y: 227.64,
    width: 2.26,
    height: 58.61,
    transform: "translate(549.66 -35.77) rotate(90)",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M377.8,375.45c-8.72.31-18.62-2.4-23.78-10-4.28-6.28-3.95-14.54-.79-21.22a26,26,0,0,1,7.07-9c3.67-3,8-5.16,12.17-7.31,7.94-4.06,17.08-9.11,19.75-18.32,2.35-8.1-2.22-16.44-8.88-21a26.27,26.27,0,0,0-16-4.33c-.13-.46-.27-.9-.43-1.34-2.6-6.84-9.06-11.66-15.86-13.8a36,36,0,0,0-24,1,34.13,34.13,0,0,0-5.38,2.76c-.55.35-.05,1.24.5.89a34.82,34.82,0,0,1,22.88-5c7.26,1,14.41,4.29,18.72,10.38a17.4,17.4,0,0,1,2.52,5.11,25.06,25.06,0,0,0-5.81,1.23c-3.38,1.14-8.53,3.43-8.16,7.75a6.84,6.84,0,0,0,6.32,5.88c3.76.18,6.91-2.88,8.28-6.13a13.22,13.22,0,0,0,.67-7.79,25.23,25.23,0,0,1,15.19,4.15c6.63,4.46,11,12.84,8.21,20.76-1.51,4.24-4.71,7.69-8.21,10.41A73.25,73.25,0,0,1,371,327.54a61.51,61.51,0,0,0-11.57,7.1,26.69,26.69,0,0,0-6.8,8.56c-3.1,6.19-3.94,13.74-1,20.14,3.57,7.72,11.85,11.77,19.93,12.84a37.29,37.29,0,0,0,6.25.29C378.45,376.45,378.46,375.42,377.8,375.45Zm-11-86.83c-.12,3.57-1.9,7.31-5.23,8.94a5.69,5.69,0,0,1-4.87.19,6.09,6.09,0,0,1-3.1-3.14c-1.74-4.24,3.61-6.78,6.81-7.91a24.8,24.8,0,0,1,6.08-1.3A12.85,12.85,0,0,1,366.82,288.62Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M459.39,285.76a71.53,71.53,0,0,0-19.75,4.71,64.67,64.67,0,0,0-17.12,9.83c-4.86,4-8.92,9-10.85,15.06,0,.07,0,.14-.07.21a44.33,44.33,0,0,0-8,3.63,56.18,56.18,0,0,0-13,10,57.24,57.24,0,0,0-15.15,28.47c-.26,1.29-.46,2.6-.62,3.91-.09.65.93.84,1,.18a55.54,55.54,0,0,1,12-28,56.48,56.48,0,0,1,11.2-10.53,47.65,47.65,0,0,1,12.15-6.43,22.47,22.47,0,0,0-.63,7.66c.29,3,1.25,6.13,3.65,8.08a6.92,6.92,0,0,0,3.64,1.58,7.1,7.1,0,0,0,4.38-1.16,11.3,11.3,0,0,0,4.92-6.59,9.69,9.69,0,0,0-1.38-7.95,9.28,9.28,0,0,0-6.71-3.79,17.46,17.46,0,0,0-6.3.57,30.52,30.52,0,0,1,8.1-12.14,57.86,57.86,0,0,1,15.62-10.16,70.11,70.11,0,0,1,18.28-5.55c1.55-.24,3.1-.44,4.67-.58A.52.52,0,0,0,459.39,285.76Zm-46.51,30.56a14.7,14.7,0,0,1,7.67-.36,8,8,0,0,1,5.51,5.22,9.06,9.06,0,0,1-1.17,7.87c-1.54,2.28-4.34,4.54-7.27,4s-4.76-3.26-5.5-6a19.47,19.47,0,0,1-.11-8.95c.11-.56.27-1.11.42-1.65Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M297.5,429.29c-2.47-12.4-3.69-25.49-.33-37.85,2.67-9.82,8.65-19,17.35-24.48a30.83,30.83,0,0,1,14.3-4.65c5.4-.39,10.82.19,16.21-.26,5.09-.43,10-2,13.81-5.41a23.18,23.18,0,0,0,7-12.4c2.1-10-2.83-20.13-10.74-26.15-7.71-5.86-19.05-8.11-27.74-3a16.43,16.43,0,0,0-2.66,2,29.76,29.76,0,0,0-12.82-3.93c-10.17-.7-20,4.65-25.56,13.11a27.87,27.87,0,0,0-3.12,6.51c-.25.76,1,1,1.21.29a27.91,27.91,0,0,1,20.74-18.27,27.52,27.52,0,0,1,18.63,3.2c-4.78,5-6.65,13-3.47,19.29,2.11,4.2,7,7.75,11.69,5.29a9.34,9.34,0,0,0,4.26-5.07,11.47,11.47,0,0,0-.17-7.43c-1.64-4.92-5.47-9.06-9.7-11.93l-.6-.38a12.65,12.65,0,0,1,1.37-1c8.12-5.39,19.3-3.43,26.8,2.11,7.73,5.71,12.71,15.51,10.67,25.17a22,22,0,0,1-6.89,12c-3.84,3.36-8.76,4.64-13.76,4.95s-10.25-.18-15.36.21a32,32,0,0,0-13.45,4c-8.22,4.64-14.34,12.61-17.71,21.33-4.23,11-4.24,23.16-2.65,34.67.39,2.86.89,5.71,1.46,8.55C296.46,430.44,297.65,430.07,297.5,429.29Zm34.39-104.44c2.93,3.82,5.26,9.35,2.42,13.86a6.92,6.92,0,0,1-5.43,3.42c-2.66.06-5-1.86-6.5-3.93-4.22-5.95-2.46-14.61,2.51-19.63A26.58,26.58,0,0,1,331.89,324.85Z",
    style: {
      fill: "#ebebeb"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Floor--inject-45"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M40.29,456.92c134.35-.61,285.07-.62,419.42,0-134.35.62-285.07.61-419.42,0Z",
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Character--inject-45"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M370.25,454.16c3.43-1.15.38-11.07-3.44-14.14-1.22-1-5.73-3.26-11.39-6-12.45-6-30.36-14-30.36-14l15.26-64.63-62.16.34s-17,60.7-16.88,64.47c0,.23,0,.47,0,.7.53,17.13,1.38,31.15,2.79,32C267.86,455.34,366.79,455.32,370.25,454.16Z",
    style: {
      fill: "#eb9481"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M370.25,454.16c-3.46,1.16-102.4,1.18-106.16-1.21-1.41-.88-2.26-14.9-2.79-32,0-.23,0-.47,0-.7a69.4,69.4,0,0,1,1.94-9.08h63.93l-2.1,8.9s17.91,8,30.36,14c5.66,2.73,10.17,5,11.39,6C370.64,443.09,373.68,453,370.25,454.16Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M371.36,454.71c-3.52,1.19-104.25,1.07-108.08-1.37-1.48-.91-2.31-15.58-2.82-33.35,0-.19,0-.37,0-.56l65-.65,0,1.11s38.53,17.29,42.47,20.42S374.88,453.55,371.36,454.71Z",
    style: {
      fill: "#FFC727"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M370.23,450.81c-17-.44-85.51-.6-102.33.26-.14,0-.14.1,0,.11,16.82.8,85.35.4,102.33-.09C370.58,451.07,370.58,450.82,370.23,450.81Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M332.68,419c-6.69-1.26-14.86-.24-20,4.51-.2.19.07.46.28.4a94.11,94.11,0,0,1,19.66-4.07A.43.43,0,0,0,332.68,419Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M337.5,421.89c-6.69-1.26-14.86-.24-20,4.51-.2.19.07.47.28.4a94.11,94.11,0,0,1,19.66-4.07A.43.43,0,0,0,337.5,421.89Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M342.32,424.8c-6.69-1.25-14.86-.24-20,4.52-.2.18.07.46.28.39a94.11,94.11,0,0,1,19.66-4.07A.43.43,0,0,0,342.32,424.8Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M341.38,404.41c-2.62-3.62-7.51-2-10.3.34a35.63,35.63,0,0,0-10.31,15.3.18.18,0,0,0,.15.24c0,.51.48,1,1.05.84,5.52-2,11.68-3.54,16.41-7.21C341.14,411.78,343.86,407.83,341.38,404.41Zm-11.67,11.92c-2.69,1.06-5.42,2-8.07,3.16a105.78,105.78,0,0,1,6.22-8.8,40,40,0,0,1,3.54-3.82c2-1.81,9.87-5.65,8.68,1.68C339.43,412.59,332.92,415.05,329.71,416.33Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M303.79,418.28c5.5,2.36,11.83,2.25,17.69,2.82a.83.83,0,0,0,.8-1.07.18.18,0,0,0,.09-.28,35.79,35.79,0,0,0-13.84-12.19c-3.3-1.55-8.44-1.88-10.06,2.28C296.94,413.78,300.57,416.91,303.79,418.28Zm-3-4.76c-3-6.8,5.59-5.07,8-3.83a37.93,37.93,0,0,1,4.39,2.8,105.32,105.32,0,0,1,8.24,6.94c-2.86-.45-5.73-.66-8.6-1C309.35,418,302.43,417.26,300.77,413.52Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M189.43,315.22s-11.14,40.34,8.31,52.28c13,8,70.39-3.05,72.83-10.15,4.61-13.4,4.62-18.31,4.62-18.31L260.45,410.1l72.31.85s13.57-58.79,10.08-121.18c-1.29-23.07-32.3-30-53.87-18.58-20.91,11.13-58.37,42-58.37,42Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M266.55,368.46c3.9-9.54,3.59-13.28,13.33-42.88,1.3-4,2.39-8,3.55-12,1.2-4.15,2.63-8.28,3.54-12.5,0-.2.38-.12.32.08-1.12,3.66-1.85,7.44-2.82,11.14s-1.91,7.25-2.92,10.85c-.44,1.56-.9,3.11-1.34,4.67l.57-1c.85-1.46,1.71-2.92,2.59-4.36,1.82-3,4-5.74,5.63-8.84.1-.18.4,0,.29.16-1.84,3-3.15,6.24-4.87,9.27-.84,1.47-1.71,2.91-2.61,4.34a27.48,27.48,0,0,1-2.59,3.84c-1.33,4.57-4.18,15.58-5.6,20.12-4.48,14.31-3,9.65-6.35,17.33C267.1,369.15,266.38,368.87,266.55,368.46Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M299.49,398.36c-10.89-.12-21.75-.74-32.64-.94-.2,0-.23-.33,0-.33,10.85-.06,21.68-.49,32.53-.36s21.75.67,32.63,1c.27,0,.32.44,0,.44C321.17,398.23,310.34,398.47,299.49,398.36Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M272.81,394.72c1-4.81,2.39-9.53,3.66-14.27s2.54-9.49,3.85-14.22c2.62-9.47,5.35-18.91,8.08-28.35,1.54-5.36,3.22-10.69,4.86-16a.12.12,0,0,1,.24.06q-7.28,28.56-15.63,56.83c-1.58,5.34-3,10.76-4.89,16A.09.09,0,0,1,272.81,394.72Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M197.74,367.49c-19.45-11.93-8.31-52.27-8.31-52.27l34.69-1.7L271.36,355c-.25.74-.51,1.52-.79,2.33C268.13,364.45,210.73,375.47,197.74,367.49Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M333.12,409.31c-.23,1.08-.36,1.63-.36,1.63l-72.31-.84,11.34-54.69Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.34,464.5c-.65,3.56,9.52,5.67,14,3.79,1.43-.6,5.62-3.44,10.74-7.09,11.24-8,26.88-19.86,26.88-19.86l53.13,3.21,29.65-54.65s-48.87-2.82-52.22-4.55L123,385c-15.27-7.78-28-13.79-29.42-13C89.62,374.2,42,460.91,41.34,464.5Z",
    style: {
      fill: "#eb9481"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.89,386.76l-27.95,55.3L93,441.34S77.37,453.17,66.12,461.2c-5.11,3.64-9.29,6.49-10.73,7.09-4.53,1.88-14.7-.23-14-3.8S89.62,374.2,93.53,372c1.44-.8,14.16,5.2,29.41,13,.22.1.42.22.62.32C124.39,385.78,128,386.27,132.89,386.76Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.32,465.21c.66-3.66,49.28-91.88,53.26-94.06,1.5-.86,14.77,5.48,30.58,13.59l.5.26L93.93,442.27l-1-.55S59.26,467.16,54.62,469.1,39.65,468.85,40.32,465.21Z",
    style: {
      fill: "#FFC727"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.29,466.09c8.56-14.67,41.71-74.65,49.05-89.8.06-.12,0-.17-.09-.05-8.8,14.35-41.46,74.6-49.2,89.72C43.88,466.28,44.11,466.4,44.29,466.09Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.27,448.52c4.32-5.25,7.37-12.91,5.66-19.68-.07-.26-.44-.16-.48.06a94.22,94.22,0,0,1-5.9,19.19A.42.42,0,0,0,90.27,448.52Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.4,451.34c4.32-5.25,7.36-12.9,5.66-19.67-.07-.27-.44-.17-.49.05a93.6,93.6,0,0,1-5.9,19.19A.43.43,0,0,0,85.4,451.34Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.52,454.16c4.32-5.25,7.37-12.9,5.66-19.67-.06-.26-.43-.17-.48.06a93.7,93.7,0,0,1-5.9,19.18A.42.42,0,0,0,80.52,454.16Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.84,463.16c4.44-.55,5.37-5.62,4.67-9.19a35.67,35.67,0,0,0-8.44-16.4.18.18,0,0,0-.29,0,.83.83,0,0,0-1.24.51C92.67,443.92,91,450,92,456,92.5,459.4,94.65,463.69,98.84,463.16Zm-4.82-16c.36-2.87.86-5.7,1.12-8.59a106.92,106.92,0,0,1,4.71,9.69,38.82,38.82,0,0,1,1.65,4.95c.62,2.61.19,11.36-5.66,6.79C92.61,457.51,93.59,450.62,94,447.19Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.79,423.53c-4.71,3.69-7.66,9.3-11,14.15a.83.83,0,0,0,.56,1.22.18.18,0,0,0,.19.21,35.66,35.66,0,0,0,17.35-6.26c2.95-2.13,5.72-6.48,2.85-9.91C112,419.7,107.54,421.38,104.79,423.53Zm5.63-.34c7.4.64,1.75,7.34-.49,8.83a38.85,38.85,0,0,1-4.57,2.5,106.35,106.35,0,0,1-10,3.88c1.78-2.28,3.34-4.7,5-7C102.37,428.55,106.34,422.84,110.42,423.19Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M235.18,305.35A294.14,294.14,0,0,1,236.85,335s68.68,36,71.82,70.21c1.11,12.12-.51,34.83-24.27,45.17C257.85,461.91,111.11,454,111.11,454l18.33-67.56,64.72,0s-45.67,7.27-50.63-23.16c-4.61-28.29,12.76-57.9,12.76-57.9Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.27,450.64c1.61-7.78,3.18-15.61,5-23.35S135,411.8,137,404.11c.58-2.18,1.17-4.34,1.76-6.51.28-1,.56-2.07.86-3.1s.54-2.11.95-3.1c0-.11.17,0,.16.06a51.17,51.17,0,0,1-1.17,6c-.41,1.88-.8,3.76-1.21,5.64q-1.26,5.79-2.59,11.57c-1.78,7.72-3.74,15.37-5.75,23q-1.71,6.52-3.44,13C126.53,451,126.21,450.9,126.27,450.64Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M171.82,386.41c5.24-.38,10.49-.55,15.75-.66s10.51-.05,15.77.05,10.51.37,15.75.84a114.22,114.22,0,0,1,15.61,2.26l-3.91-.51-3.91-.37c-2.62-.22-5.23-.44-7.85-.56-5.23-.3-10.47-.51-15.72-.6s-10.49-.22-15.74-.29Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M170.67,310.89a189.27,189.27,0,0,0-6.1,18.38,117.94,117.94,0,0,0-3.74,18.94,53.94,53.94,0,0,0-.2,9.59,23.64,23.64,0,0,0,2.33,9.11,12.56,12.56,0,0,0,2.8,3.66,22.61,22.61,0,0,0,3.85,2.71,43.25,43.25,0,0,0,8.83,3.55,119.13,119.13,0,0,0,18.94,3.43c6.4.75,12.84,1.27,19.28,1.92a140.36,140.36,0,0,1,19.24,3,37.46,37.46,0,0,1,9.25,3.41,43.46,43.46,0,0,1,8,5.7l1.45,1.29-2,0-52.33-.7-26.17-.21c-8.72,0-17.44-.05-26.17.18,8.72-.5,17.44-.64,26.17-.8s17.45-.17,26.17-.19l26.18,0,26.17.24-.51,1.27a42,42,0,0,0-7.76-5.45,35.81,35.81,0,0,0-8.91-3.23,152.65,152.65,0,0,0-19-2.94c-6.41-.69-12.85-1.24-19.29-2a120.89,120.89,0,0,1-19.15-3.57,41.54,41.54,0,0,1-9.08-3.76,23.9,23.9,0,0,1-4-2.92,13.91,13.91,0,0,1-3-4,24.84,24.84,0,0,1-2.33-9.57,54.82,54.82,0,0,1,.34-9.76,112.49,112.49,0,0,1,4.14-19A170.13,170.13,0,0,1,170.67,310.89Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M227.69,304.64a.13.13,0,0,1,.26,0c.27,2.34,1.09,15.7,1.5,20.73.14,1.8,0,5,2.66,5,2.07,0,3.1-2.25,3.33-4,.28-2.14-.87-17.65-1.13-22.81,0-.15.23-.16.25,0,.95,5.17,2.8,21.63,2.25,23.94-.43,1.8-1.36,3.52-3.2,4.13a33.46,33.46,0,0,1-.09,6.1c0,.17-.54.21-.58.08h0c.09-1.21-.55-5.9-.53-5.92a3.71,3.71,0,0,1-3.33-1.52C227.25,327.9,227.65,310.59,227.69,304.64Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M220.27,344.27c1.88-1.29,3.81-2.46,5.76-3.62s3.93-2.24,5.93-3.31,4-2.08,6.09-3,4.13-1.87,6.28-2.62c-1,.59-2,1.12-3,1.7l-3,1.65c-2,1.11-4,2.17-6,3.23s-4,2.1-6,3.09l-3,1.49C222.34,343.33,221.32,343.83,220.27,344.27Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M171.53,333.53c3.64,0,15,.65,20.42-3.92,4.38-3.7,6.3-16.34,7.06-19.81,0-.17.29-.11.29.05a39.56,39.56,0,0,1-1.47,11.6c-.88,3.2-2.06,6.77-4.65,9s-6.42,3.19-9.9,3.62a45.39,45.39,0,0,1-11.76-.16A.2.2,0,0,1,171.53,333.53Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M232.55,236.51c11.53,17.14,27.54,48.35,45.38,51.75,17,3.24,47.73-34.27,56.57-46.87,3.21-4.56-30.47-26.63-34.69-22.83-7.95,7.16-23.32,27.54-26,27.19s-12.82-9.1-34-24.44C227,212,219.57,217.19,232.55,236.51Z",
    style: {
      fill: "#eb9481"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M331.34,245.15c3.7-2.87,19.53-17.53,23-22.6s12.48-20.36,8.87-23.43-6.6,1.2-6.6,1.2,2.78-7.06-1.14-9.82-8.34,4-8.34,4,2.32-7.46-1.78-9.93-7.41,5.11-7.41,5.11,2.43-6.73-1.8-7.34c-5.09-.74-8.19,12.16-12.46,17.46-1,1.21-21.41,23-21.41,23Z",
    style: {
      fill: "#eb9481"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M338.25,189.07c-2.29,9.49-4.94,13.24-11.84,19.92-.13.13,0,.36.19.24,7.34-5.93,11.34-10.16,12.12-20.07C338.76,188.68,338.36,188.62,338.25,189.07Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M347.32,193.78c-3.25,9.64-6.08,13.74-12.79,21.27-.1.11.08.28.18.18,7.2-6.84,11.09-11.15,13.07-21.21C347.87,193.57,347.47,193.34,347.32,193.78Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M356.28,200.69c-3.82,9.11-6.73,13.73-14.18,20.21a.18.18,0,0,0,.22.29c8.24-5.87,11.92-11.61,14.22-20.35C356.7,200.24,356.52,200.12,356.28,200.69Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M295.89,224.76s1.81-12.09,3.78-17.23S316,186,319.75,188.86c4.81,3.75-1.63,14.88-5.49,19.91,0,0,11.14,8.67,8.25,17.65S295.89,224.76,295.89,224.76Z",
    style: {
      fill: "#eb9481"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M320.73,190.33c1.92,6.58-3.58,12.87-7,18a.57.57,0,0,0,.31.88c4.43,3.94,9.52,10.79,8.77,17a.14.14,0,0,0,.28.06c1.71-6.55-2.75-13.69-7.87-17.7,3.55-5.24,8.79-11.79,5.53-18.29C320.77,190.27,320.72,190.28,320.73,190.33Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M291,222.93l35,32.55S292.16,295.56,278,292c-16.26-4.08-38.41-34.56-50.1-61.81-8.09-18.85,4.19-18.9,14.94-9.68,11.21,9.6,30.52,23.4,31.78,23S291,222.93,291,222.93Z",
    style: {
      fill: "#FFC727"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M246.13,223.23a2.56,2.56,0,0,0-.59.9,2.3,2.3,0,0,0-.14,1.56c.08.49.14.95.25,1.41a12.57,12.57,0,0,0,.3-1.41,2.71,2.71,0,0,1,.4-1.17,2.37,2.37,0,0,1,.6-.62Zm-20.72-1.49a.19.19,0,0,1,0,.08l.09-.15ZM299.61,268a2.72,2.72,0,0,1-1.16-.41,2.16,2.16,0,0,1-1-1.92,3,3,0,0,0-1.88-2.67A3,3,0,0,0,294,263a12,12,0,0,0-1.45.29c.49.12.95.17,1.45.27a2.83,2.83,0,0,1,1.19.37,2.22,2.22,0,0,1,1.07,1.86,2.91,2.91,0,0,0,1.79,2.69,2.7,2.7,0,0,0,1.57.17c.49-.11,1-.17,1.42-.29A10.81,10.81,0,0,0,299.61,268Zm-43.07-20.34a2.84,2.84,0,0,1-1.19-.39,2.25,2.25,0,0,1-1-1.92,2.91,2.91,0,0,0-1.88-2.67,3,3,0,0,0-1.57-.11c-.49.11-1,.17-1.42.29a10.81,10.81,0,0,0,1.42.28,2.66,2.66,0,0,1,1.19.38,2.23,2.23,0,0,1,1.11,1.86A2.87,2.87,0,0,0,255,248.1a2.68,2.68,0,0,0,1.59.15A12.79,12.79,0,0,0,258,248C257.47,247.85,257,247.79,256.54,247.69Zm58.29-3a11.14,11.14,0,0,0-.28-1.42c-.11.43-.17.85-.27,1.3l0,.12a2.69,2.69,0,0,1-.35,1.19,2.14,2.14,0,0,1-1.85,1.07,3,3,0,0,0-2.72,1.8,2.94,2.94,0,0,0-.14,1.57,12.19,12.19,0,0,0,.28,1.44,10.49,10.49,0,0,0,.29-1.44,2.48,2.48,0,0,1,.41-1.17,2.15,2.15,0,0,1,1.91-1,3,3,0,0,0,2.67-1.88,2.54,2.54,0,0,0,.14-1.13A2.75,2.75,0,0,0,314.83,244.73Zm-45.34,17.94a10.49,10.49,0,0,0-.28-1.42c-.11.46-.18.92-.29,1.42a2.82,2.82,0,0,1-.35,1.19,2.19,2.19,0,0,1-1.86,1.07,3,3,0,0,0-2.72,1.79,3,3,0,0,0-.14,1.57,12.35,12.35,0,0,0,.28,1.45,12.45,12.45,0,0,0,.3-1.45,2.47,2.47,0,0,1,.4-1.16,2.17,2.17,0,0,1,1.91-1,3,3,0,0,0,2.67-1.88A2.74,2.74,0,0,0,269.49,262.67Zm17.55,20a2.2,2.2,0,0,1-1.09.54,2.11,2.11,0,0,1-2.06-.63,3,3,0,0,0-3.22-.55,2.77,2.77,0,0,0-1.19,1c-.26.41-.58.79-.81,1.22.43-.26.81-.56,1.22-.81a2.41,2.41,0,0,1,1.1-.58,2.15,2.15,0,0,1,2.08.52,2.86,2.86,0,0,0,3.16.66,2.79,2.79,0,0,0,1.25-1c.26-.4.55-.78.78-1.22C287.83,282.1,287.45,282.38,287,282.65Zm3-40.48a2.34,2.34,0,0,1-1.1.55,2.15,2.15,0,0,1-2.06-.64,2.92,2.92,0,0,0-3.21-.54,2.79,2.79,0,0,0-1.2,1c-.25.4-.57.78-.81,1.22.44-.27.81-.56,1.22-.82a2.32,2.32,0,0,1,1.11-.57,2.15,2.15,0,0,1,2.08.52,2.84,2.84,0,0,0,4.4-.35c.27-.41.55-.79.79-1.22C290.81,241.62,290.44,241.9,290,242.17Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M315.74,262c-5.06-4.48-25.09-23.54-29.14-27.95-.28-.31-.15-.56.18-.28,15.48,13,24.39,23.38,29.13,28C316,261.87,315.87,262.07,315.74,262Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M275.67,291.24c-16-6.22-36.59-35.09-47.73-61-4.45-10.38-2.73-15.06,1.51-15.63C243.27,235.8,261.47,267,275.67,291.24Z",
    style: {
      fill: "#000102",
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143.77,323.79l96.46,10.44c-.54,1.81,9.55-58.05,1.77-109.43-1.61-10.65-18.71-13.29-26.86-9.27C179.43,233.15,143.9,323,143.77,323.79Z",
    style: {
      fill: "#FFC727"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M223.39,302.89a2.65,2.65,0,0,1-1.14.54,2.22,2.22,0,0,1-2.05-.63,2.85,2.85,0,0,0-3.22-.56,3,3,0,0,0-1.19,1.05c-.26.38-.54.75-.81,1.18a10.66,10.66,0,0,0,1.22-.8,4.1,4.1,0,0,1,1.1-.59,2.26,2.26,0,0,1,2.09.56,2.91,2.91,0,0,0,3.16.66,2.79,2.79,0,0,0,1.24-1c.26-.4.55-.78.78-1.22A12.53,12.53,0,0,0,223.39,302.89Zm-61.65,5.24a2.16,2.16,0,0,1-1.1.55,2.18,2.18,0,0,1-2.08-.61,2.89,2.89,0,0,0-3.19-.58,3.16,3.16,0,0,0-1.19,1,11.83,11.83,0,0,0-.82,1.22,9.93,9.93,0,0,0,1.22-.81,2.56,2.56,0,0,1,1.1-.58,2.19,2.19,0,0,1,2.06.55,2.83,2.83,0,0,0,4.41-.34c.25-.41.58-.79.81-1.22C162.53,307.58,162.15,307.87,161.74,308.13Zm28.09-45.62a2.34,2.34,0,0,1-1.1.55,2.17,2.17,0,0,1-2.06-.63,2.93,2.93,0,0,0-3.21-.55,2.77,2.77,0,0,0-1.19,1c-.26.4-.58.78-.82,1.22.44-.27.82-.56,1.22-.82a2.32,2.32,0,0,1,1.11-.57,2.15,2.15,0,0,1,2.08.52,2.87,2.87,0,0,0,3.16.66,3,3,0,0,0,1.25-1c.26-.41.54-.79.78-1.22C190.62,262,190.24,262.25,189.83,262.51Zm34.46-40a2.47,2.47,0,0,1-1.11.55,2.13,2.13,0,0,1-2.05-.63,3,3,0,0,0-3.22-.55,2.83,2.83,0,0,0-1.19,1c-.26.41-.58.79-.81,1.22.43-.26.81-.55,1.22-.81a2.48,2.48,0,0,1,1.09-.58,2.16,2.16,0,0,1,2.09.52,2.86,2.86,0,0,0,4.41-.35c.27-.41.55-.78.79-1.22C225.07,221.94,224.69,222.23,224.29,222.48Zm5.12,26.5c-.11-.47-.17-.93-.29-1.42-.14.49-.2.95-.29,1.42a2.93,2.93,0,0,1-.37,1.22,2.17,2.17,0,0,1-1.86,1.07,2.88,2.88,0,0,0-2.69,1.8,2.3,2.3,0,0,0-.14,1.56c.08.49.14,1,.25,1.42a10.82,10.82,0,0,0,.29-1.42,2.86,2.86,0,0,1,.41-1.16,2.17,2.17,0,0,1,1.91-1,3,3,0,0,0,2.67-1.89A3.36,3.36,0,0,0,229.41,249ZM187,284.22a12.74,12.74,0,0,0-.28-1.42c-.12.46-.18.93-.3,1.42a2.69,2.69,0,0,1-.35,1.19,2.14,2.14,0,0,1-1.85,1.07,3,3,0,0,0-2.72,1.8,3,3,0,0,0-.15,1.57,14.68,14.68,0,0,0,.29,1.44,10.49,10.49,0,0,0,.29-1.44,2.48,2.48,0,0,1,.41-1.17,2.15,2.15,0,0,1,1.91-1,3,3,0,0,0,2.66-1.88A2.84,2.84,0,0,0,187,284.22Zm56-6.85a3.34,3.34,0,0,1-1.11.61,2.27,2.27,0,0,1-2.09-.56,2.93,2.93,0,0,0-3.15-.66,2.68,2.68,0,0,0-1.24,1c-.27.41-.56.79-.82,1.22.44-.26.82-.55,1.22-.81a2.92,2.92,0,0,1,1.1-.55,2.35,2.35,0,0,1,2.09.63,2.94,2.94,0,0,0,3.22.56,3.12,3.12,0,0,0,1.19-1.05c.25-.4.55-.77.77-1.21C243.8,276.82,243.43,277.11,243,277.37Zm-30,.94a2.84,2.84,0,0,1-1.16-.38,2.18,2.18,0,0,1-1-1.91,3,3,0,0,0-1.89-2.67,2.68,2.68,0,0,0-1.57-.11c-.49.11-.95.17-1.44.28a10.54,10.54,0,0,0,1.44.3,2.69,2.69,0,0,1,1.2.35A2.19,2.19,0,0,1,209.7,276a3,3,0,0,0,1.8,2.72,2.77,2.77,0,0,0,1.57.15c.49-.09,1-.15,1.45-.29C214,278.48,213.56,278.42,213.07,278.31Zm-20.13,37.48a2.84,2.84,0,0,1-1.19-.39,2.26,2.26,0,0,1-1-1.92,2.86,2.86,0,0,0-3.45-2.78c-.49.11-.95.17-1.42.29a11.14,11.14,0,0,0,1.42.28,2.66,2.66,0,0,1,1.19.38,2.2,2.2,0,0,1,1.11,1.86,2.86,2.86,0,0,0,1.77,2.69,2.66,2.66,0,0,0,1.59.15,13.79,13.79,0,0,0,1.42-.29C193.86,316,193.4,315.89,192.94,315.79Zm31.66,16a2.67,2.67,0,0,1-1.18-.41,2.22,2.22,0,0,1-1-1.92,2.88,2.88,0,0,0-1.88-2.66,3,3,0,0,0-1.56-.09c-.46.09-.95.15-1.42.27a12.27,12.27,0,0,0,1.42.28,3,3,0,0,1,1.18.38,2.2,2.2,0,0,1,1.11,1.85,2.85,2.85,0,0,0,1.77,2.7,2.48,2.48,0,0,0,.82.21,3.23,3.23,0,0,0,.77,0c.46-.12.92-.18,1.43-.3C225.52,332,225.06,331.93,224.6,331.84Zm-19.25-88.3a2.72,2.72,0,0,1-1.17-.41,2.16,2.16,0,0,1-1-1.92,3,3,0,0,0-1.88-2.66,3,3,0,0,0-1.57-.09c-.49.09-.95.15-1.45.29.5.12,1,.17,1.45.27a3,3,0,0,1,1.19.37,2.22,2.22,0,0,1,1.07,1.86,2.93,2.93,0,0,0,1.8,2.7,2.86,2.86,0,0,0,1.57.17c.49-.12,1-.17,1.42-.3A11.14,11.14,0,0,0,205.35,243.54Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M202.4,227.22c-23.93,29.11-51.71,87-44.49,97.84,8,12.07,41.06-27.4,40.72-29.57-.26-1.65,9.56-37,17.1-62.69S208.32,220,202.4,227.22Z",
    style: {
      fill: "#eb9481"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M198.88,295.5c.79-3.75,14.27-50.37,18-65.06s-1.33-18.68-14.49-4.33-40.13,58.54-45.21,82.31c-4.89,22.9,6.05,24.08,20.25,12.44C189.07,311.33,198.88,295.5,198.88,295.5Z",
    style: {
      fill: "#FFC727"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M205.35,243.54a2.72,2.72,0,0,1-1.17-.41,2.16,2.16,0,0,1-1-1.92,3,3,0,0,0-1.88-2.66,3,3,0,0,0-1.57-.09c-.49.09-.95.15-1.45.29.5.12,1,.17,1.45.27a3,3,0,0,1,1.19.37,2.22,2.22,0,0,1,1.07,1.86,2.93,2.93,0,0,0,1.8,2.7,2.86,2.86,0,0,0,1.57.17c.49-.12,1-.17,1.42-.3A11.14,11.14,0,0,0,205.35,243.54ZM187.28,310.7c-.49.11-.95.17-1.42.29a9.51,9.51,0,0,0,1.29.26l.51-.6A2.18,2.18,0,0,0,187.28,310.7ZM187,284.22a12.74,12.74,0,0,0-.28-1.42c-.12.46-.18.93-.3,1.42a2.69,2.69,0,0,1-.35,1.19,2.14,2.14,0,0,1-1.85,1.07,3,3,0,0,0-2.72,1.8,3,3,0,0,0-.15,1.57,14.68,14.68,0,0,0,.29,1.44,10.49,10.49,0,0,0,.29-1.44,2.48,2.48,0,0,1,.41-1.17,2.15,2.15,0,0,1,1.91-1,3,3,0,0,0,2.66-1.88A2.84,2.84,0,0,0,187,284.22Zm31.05-62.43-.15.06a2.83,2.83,0,0,0-1.19,1c-.26.41-.58.79-.81,1.22.43-.26.81-.55,1.22-.81a2.53,2.53,0,0,1,.94-.54A7.79,7.79,0,0,0,218.06,221.79Zm-28.23,40.72a2.34,2.34,0,0,1-1.1.55,2.17,2.17,0,0,1-2.06-.63,2.93,2.93,0,0,0-3.21-.55,2.77,2.77,0,0,0-1.19,1c-.26.4-.58.78-.82,1.22.44-.27.82-.56,1.22-.82a2.32,2.32,0,0,1,1.11-.57,2.15,2.15,0,0,1,2.08.52,2.87,2.87,0,0,0,3.16.66,3,3,0,0,0,1.25-1c.26-.41.54-.79.78-1.22C190.62,262,190.24,262.25,189.83,262.51Zm-28.09,45.62a2.16,2.16,0,0,1-1.1.55,2.18,2.18,0,0,1-2.08-.61,2.78,2.78,0,0,0-1.14-.68c-.08.35-.16.69-.23,1,0,0,0,.07,0,.1a1.61,1.61,0,0,1,.57.39,2.83,2.83,0,0,0,4.41-.34c.25-.41.58-.79.81-1.22C162.53,307.58,162.15,307.87,161.74,308.13Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M197.16,301.53c1.14-4.69,2.35-9.36,3.58-14s2.5-9.31,3.75-14l3.91-13.93,2-7c.69-2.31,1.37-4.63,2.08-6.93-.56,2.34-1.17,4.68-1.75,7l-1.82,7-3.76,14c-1.3,4.64-2.58,9.29-3.91,13.93S198.58,296.92,197.16,301.53Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M209.71,256.57a26.42,26.42,0,0,1,1.56-3.47c.29-.56.59-1.11.92-1.66s.65-1.08,1-1.62a17.59,17.59,0,0,1-1.45,3.53A23.46,23.46,0,0,1,209.71,256.57Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M158,325c6.6,8.54,21.71,9.86,64,16.06,5.86.86,24.28-39.57,18.08-40.81-7.82-1.56-38.49-5.92-40.77-5.95C180,294,153.47,319.21,158,325Z",
    style: {
      fill: "#eb9481"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M225.69,300.15s16.07-1.68,26.64-2.29c5.9-.34,16.06,0,20.5,1.72,6.65,2.59,32.8,17.67,29.28,24.09-3.19,5.81-24-10-24-10s22.42,14.1,17.3,20.39-26.28-14.7-26.28-14.7,22.71,15,16.4,20.65c-4.77,4.27-25-13.66-25-13.66s19.43,13,14.72,17.63c-5.22,5.09-24.92-10.3-24.92-10.3-14,9.68-24.56,8.59-32,6.91C216.51,340.18,225.69,300.15,225.69,300.15Z",
    style: {
      fill: "#eb9481"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M270.66,308.3c2.69,1.56,5.43,3.12,8,4.91s5,3.69,7.4,5.71a52.46,52.46,0,0,1,8.46,8.75c-4.81-5.41-13.83-12-16.37-13.77s-5-3.71-7.53-5.51C270.52,308.35,270.59,308.26,270.66,308.3Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M264,317.37c3.35,2.14,6.76,4.15,10,6.44s6.12,4.72,9.2,7.22c.24.19,0,.26-.19.07-3.18-2.37-6.29-4.32-9.5-6.65s-6.31-4.8-9.59-7C263.9,317.41,264,317.34,264,317.37Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M256.9,324.13a88.24,88.24,0,0,1,14.57,11c.23.2,0,.25-.26.06-4.77-3.75-8.49-6.73-14.41-10.89C256.71,324.25,256.79,324.07,256.9,324.13Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M235.28,298.56l-34.77,42.66s-37.1-6.9-43-16.16c-3.9-6.1,22.39-32.68,43.64-30.73Z",
    style: {
      fill: "#FFC727"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M194.86,335.42a2.8,2.8,0,0,1-1.14.55,2.27,2.27,0,0,1-2.05-.63,2.84,2.84,0,0,0-3.22-.56,3,3,0,0,0-1.19,1.05c-.26.38-.54.74-.81,1.18a12.19,12.19,0,0,0,1.22-.8,3.61,3.61,0,0,1,1.1-.59,2.26,2.26,0,0,1,2.09.56,3,3,0,0,0,3.16.66,2.86,2.86,0,0,0,1.24-1c.26-.41.55-.79.78-1.22A12.39,12.39,0,0,0,194.86,335.42Zm28.53-32.53a2.65,2.65,0,0,1-1.14.54,2.22,2.22,0,0,1-2.05-.63,2.85,2.85,0,0,0-3.22-.56,3,3,0,0,0-1.19,1.05c-.26.38-.54.75-.81,1.18a10.66,10.66,0,0,0,1.22-.8,4.1,4.1,0,0,1,1.1-.59,2.26,2.26,0,0,1,2.09.56,2.91,2.91,0,0,0,3.16.66,2.79,2.79,0,0,0,1.24-1c.26-.4.55-.78.78-1.22A12.53,12.53,0,0,0,223.39,302.89Zm-55.13,26.46c-.11-.49-.17-1-.29-1.41a10.67,10.67,0,0,0-.29,1.41,2.47,2.47,0,0,1-.38,1.2,2.18,2.18,0,0,1-.86.82l1.12.5a2.62,2.62,0,0,0,.59-.95A3.15,3.15,0,0,0,168.26,329.35Zm24.68-13.56a2.84,2.84,0,0,1-1.19-.39,2.26,2.26,0,0,1-1-1.92,2.86,2.86,0,0,0-3.45-2.78c-.49.11-.95.17-1.42.29a11.14,11.14,0,0,0,1.42.28,2.66,2.66,0,0,1,1.19.38,2.2,2.2,0,0,1,1.11,1.86,2.86,2.86,0,0,0,1.77,2.69,2.66,2.66,0,0,0,1.59.15,13.79,13.79,0,0,0,1.42-.29C193.86,316,193.4,315.89,192.94,315.79Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M176.26,302.19c3.29-2.63,12.59-8.84,24.89-7.9.11,0,.12.19,0,.19-9.23.18-21.43,5.59-24.81,7.86C176.26,302.39,176.18,302.25,176.26,302.19Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M190.14,334.86c3.57-4.9,7.4-9.6,11.24-14.29s7.68-9.39,11.64-14c2.24-2.6,4.47-5.21,6.8-7.73.06-.06.18,0,.13.1-3.57,4.89-7.38,9.61-11.19,14.31s-7.68,9.41-11.59,14.05c-2.2,2.62-4.46,5.21-6.79,7.72C190.27,335.16,190,335,190.14,334.86Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M235.32,298a51.23,51.23,0,0,0-7-1.24q-3.51-.48-7-.87c-4.67-.52-14.5-2.16-23-1.72-.1,0,.41.44.5.43,4.06-.42,33.52,4,35.92,4-.09.17-.17.33-.24.5s.09.27.21.18c.29-.22.49-.48.76-.71A.34.34,0,0,0,235.32,298Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M187.52,246.12c-8.84,15.2-38.27,63.37-30,79.14a12.53,12.53,0,0,1-1.71-5.13c-1.89-20.21,20.29-56.95,31.67-74Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M184.81,247.88c-.83,2.38-1.65,4.69-2.71,7a16.87,16.87,0,0,1,2.71-7Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M234.19,230.32c-4.61,1-14.05-4.65-17.18-11.29-.21-.45.75-5.05,1.65-10.69.54-3.43,1.05-7.26,1.26-10.79.05-.72,21.8,6.73,21.8,6.73a56.31,56.31,0,0,0-3,13.41,7.69,7.69,0,0,0,.07,1.46c0,.07,0,.15,0,.24C239.11,222.17,239.13,229.27,234.19,230.32Z",
    style: {
      fill: "#eb9481"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M238.82,219.15c0,.07,0,.16,0,.24a14.44,14.44,0,0,1-2.27,0c-13-1.08-15.44-17.59-15.85-21.76,3.89.8,21,6.67,21,6.67a56.45,56.45,0,0,0-3,13.42A7.62,7.62,0,0,0,238.82,219.15Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M244.59,159.26c1.24-.16,8.08,8.09,8.75,12.41s.39,13.14-.85,13.48S243.63,159.38,244.59,159.26Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M215.19,172.35c-1.93,8,3.55,30.41,9.43,35.13,8.52,6.85,21.8,6.77,27.45-3.32,5.48-9.79-2.18-38.88-8.69-43.1C233.8,154.84,218,160.56,215.19,172.35Z",
    style: {
      fill: "#eb9481"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M247,183.11c0-.06.13,0,.15.11.25,1.54.8,3.25,2.28,3.48,0,0,.06.09,0,.09C247.67,186.89,247,184.61,247,183.11Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M248,181.25c2.41-.67,3.58,4.21,1.34,4.83S246,181.81,248,181.25Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M238.43,185.11c0-.05-.1.1-.08.16.39,1.51.59,3.3-.67,4.11,0,0,0,.1,0,.08C239.34,188.85,239.05,186.47,238.43,185.11Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M236.72,183.84c-2.48.37-1.55,5.3.74,5S238.8,183.53,236.72,183.84Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M234.72,180.74c.65-.28,1.2-.64,1.82-1s1.28-.62,1.65-1.36a1.07,1.07,0,0,0-.37-1.24,2.62,2.62,0,0,0-2.66.15,3.9,3.9,0,0,0-1.94,2A1.13,1.13,0,0,0,234.72,180.74Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M249.22,177.64a17.79,17.79,0,0,1-2.06-.12,3.25,3.25,0,0,1-2.07-.52,1.06,1.06,0,0,1-.19-1.28,2.64,2.64,0,0,1,2.47-1,3.88,3.88,0,0,1,2.6,1A1.13,1.13,0,0,1,249.22,177.64Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M239.56,199.18c.4.33.81.8,1.37.81a4.2,4.2,0,0,0,1.64-.52s.1,0,.07.07a2.09,2.09,0,0,1-1.9,1,1.67,1.67,0,0,1-1.33-1.28C239.38,199.17,239.5,199.13,239.56,199.18Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M240.19,194.16a5.26,5.26,0,0,0,3.92,1.62,6.41,6.41,0,0,0,1.89-.28l.35-.11.32-.12a.4.4,0,0,0,.24-.4h0a1,1,0,0,0,0-.16h0l0-.13c-.2-1.18-.67-2.94-.67-2.94.47.13,2.85.68,2.7.07-1.31-5-2.77-10.6-5.13-15.31a.14.14,0,0,0-.27.09c1.06,4.87,3,9.52,4.13,14.4a9.25,9.25,0,0,0-2.59-.26c-.16.08,1,3.39,1,3.93v.06c-1.92.64-3.53.34-5.7-.6C240.18,193.93,240.08,194.06,240.19,194.16Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M245.27,195.33a6.15,6.15,0,0,1-2.12,2.23,2.7,2.7,0,0,1-1.62.35c-1.23-.13-1.43-1.22-1.35-2.18a6.61,6.61,0,0,1,.31-1.5A7.89,7.89,0,0,0,245.27,195.33Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M243.15,197.56a2.7,2.7,0,0,1-1.62.35c-1.23-.13-1.43-1.22-1.35-2.18A2.81,2.81,0,0,1,243.15,197.56Z",
    style: {
      fill: "#ff9bbc"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M219.81,192.23c4-.53,4.95-5.32,4.93-11.73,0-3.74-2.55-10.64-2.55-10.64s11.08,2.45,16.65.68,9.33-7.76,8.07-12.16c-1.08-3.78-8.64-7.31-17.21-5.77-6,1.08-14.92,8.07-17.9,15.42,0,0-6.66,5.24-4.29,10.62S215.26,192.83,219.81,192.23Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M220,191.72c5.41-.06,6.4-8.45,5.62-12.54-.81-4.24-3.39-8.14-5-12.08,0,0,0,0,0,0,2.87,4.59,6.17,10.48,5.64,16.08-.33,3.52-1.52,9.49-6.25,8.86C219.82,192,219.81,191.72,220,191.72Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M206,177.2c-.05-3.63,3.14-7.94,6.27-9.49,0,0,0,0,0,0-3.64,2.33-7.21,7.94-5,12.1,1.78,3.34,4.54,7.63,7.59,9.91.08.06,0,.17-.09.12-2.33-1.48-3.72-3.78-5.27-6C208.2,181.94,206,179.71,206,177.2Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M211.16,168.73c3.16-7.76,11.55-17.64,20.63-17.51,0,0,0,0,0,0-9.46.66-16,10.29-20.26,17.68C211.4,169.15,211.07,168.94,211.16,168.73Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M222.75,190.74s-5.69-6.91-8.87-4.82,1.51,12.39,5.53,13.53a4,4,0,0,0,5.14-2.55Z",
    style: {
      fill: "#eb9481"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M215.3,188.84a.05.05,0,0,0,0,.1c2.82.89,4.46,3.31,5.67,5.86a2.2,2.2,0,0,0-3.32-.34c-.07.06,0,.17.09.14a2.47,2.47,0,0,1,2.75.64,13.08,13.08,0,0,1,1.46,2.07c.14.24.57.07.46-.2l0-.07C222.16,193.55,219.07,188.89,215.3,188.84Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M240.69,220a38.51,38.51,0,0,1-.27,4.13,20.09,20.09,0,0,1-.7,3.7,8,8,0,0,1-4.86,5.28,10,10,0,0,1-7.27-.41,21.83,21.83,0,0,1-5.93-4.26q-1.6-1.49-3.06-3.1c-.48-.55-1-1.09-1.43-1.66s-.88-1.15-1.37-1.69c0,0-.15,0-.12.06,1,1.3,3.95,5.42,4.92,6.42a22.19,22.19,0,0,0,6,4.81,11.12,11.12,0,0,0,7.8.84A8.24,8.24,0,0,0,240,229a14,14,0,0,0,.75-4.3c.08-1.6,0-3.19,0-4.77C240.72,219.93,240.69,219.94,240.69,220Z",
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--light-bulb--inject-45"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M340.88,69.43a68.53,68.53,0,0,1-.31-16.81,69,69,0,0,1,.31,16.81Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M302.51,80.13a68.81,68.81,0,0,1-8.67-14.4,68.64,68.64,0,0,1,8.67,14.4Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M274.63,108.59a68.31,68.31,0,0,1-14.7-8.14,68.74,68.74,0,0,1,14.7,8.14Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M264.72,147.17a68.94,68.94,0,0,1-16.8.31,68.44,68.44,0,0,1,16.8-.31Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M275.43,185.54a69.33,69.33,0,0,1-14.4,8.67,68.64,68.64,0,0,1,14.4-8.67Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M408.71,184.16a68.31,68.31,0,0,1,14.7,8.14,69,69,0,0,1-14.7-8.14Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M418.62,145.58a68.94,68.94,0,0,1,16.8-.31,68.44,68.44,0,0,1-16.8.31Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M407.91,107.21a69.33,69.33,0,0,1,14.4-8.67,68.64,68.64,0,0,1-14.4,8.67Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M379.46,79.34a69,69,0,0,1,8.13-14.71,68.58,68.58,0,0,1-8.13,14.71Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.5
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M407,150.29c-3.24,40.56-37,52.79-37,52.79-2.48,6.16-5.72,21.84-5.72,21.84h-45.1s-3.24-15.68-5.72-21.84c0,0-33.79-12.23-37-52.79-2.25-28.18,17.82-69.83,65.06-69.84h.49C389.15,80.46,409.22,122.11,407,150.29Z",
    style: {
      fill: "#FFC727"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.7000000000000001
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M401.4,150.5c-3,37.09-33.87,48.27-33.87,48.27-2.27,5.64-5.23,26.15-5.23,26.15H321s-3-20.51-5.23-26.15c0,0-30.9-11.18-33.86-48.27-2.06-25.78,16.29-63.88,59.5-63.89h.44C385.1,86.62,403.45,124.72,401.4,150.5Z",
    style: {
      fill: "#FFC727"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 322.58,
    y: 157.13,
    width: 3,
    height: 72.24,
    transform: "translate(-29.96 62.76) rotate(-10.58)",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 323.15,
    y: 191.74,
    width: 72.24,
    height: 3,
    transform: "translate(103.46 511.02) rotate(-79.44)",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M341.67,181.28c-4,0-7.73-3.75-10.34-8.55a5.36,5.36,0,0,1-3.82,2.13c-6.64,0-9.31-13.73-9.42-14.32l1-.18c0,.13,2.62,13.5,8.43,13.5h0c1.05,0,2.22-.75,3.32-2.09a30.21,30.21,0,0,1-3.31-12.63c0-3.82,1.43-6,3.92-6h0a4,4,0,0,1,3.62,2.06c2,3.47.53,10.67-2.09,15.22-.31.53-.63,1-1,1.46,2.45,4.69,5.93,8.41,9.65,8.41h0c3.4,0,6.38-3.11,8.51-7.24-2.63-2.85-4.12-7.5-4.12-11.94,0-4.92,1.83-8,4.79-8,2.38,0,3.74,2.4,3.75,6.57a33.33,33.33,0,0,1-3.23,13.19,6.54,6.54,0,0,0,4.56,1.89h0c4.13,0,7.76-9.8,8.81-13.58l1,.27c-.16.58-4,14.31-9.77,14.31h0a7.46,7.46,0,0,1-5-2C348.7,178,345.55,181.28,341.67,181.28Zm9.18-27.16c-2.8,0-3.79,3.76-3.79,7,0,3.53,1.16,8.14,3.58,11a31.19,31.19,0,0,0,3-12.42C353.59,158,353.33,154.12,350.85,154.12Zm-19.41,0h0c-2.54,0-2.92,3.14-2.92,5a29.23,29.23,0,0,0,3,11.71c.2-.29.4-.61.59-.94,2.44-4.22,3.9-11.1,2.09-14.22A2.93,2.93,0,0,0,331.44,154.13Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 313.42,
    y: 224.98,
    width: 56.5,
    height: 31.1,
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M363.52,256.07c-3.33,5.89-9.7,11.16-21.85,11.16s-18.52-5.27-21.84-11.16Z",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M363.52,256.07a20.76,20.76,0,0,1-3.67,4.78l-38.9-3a19.1,19.1,0,0,1-1.12-1.8Z",
    style: {
      fill: "#a6a6a6"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "371.57 230.91 311.77 236.44 311.77 233.72 371.57 228.19 371.57 230.91",
    style: {
      fill: "#a6a6a6"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "371.57 239.12 311.77 244.65 311.77 241.93 371.57 236.4 371.57 239.12",
    style: {
      fill: "#a6a6a6"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "371.57 247.32 311.77 252.85 311.77 250.14 371.57 244.61 371.57 247.32",
    style: {
      fill: "#a6a6a6"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.5
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M290.6,140.82c2.08.34,4.76-10.35,16.25-22.72,5.11-5.5,24.48-12.37,23.09-18.72s-18.68.18-27.38,10.25C288.57,125.84,288.7,140.5,290.6,140.82Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M392.53,143c3.82,0,3.82-5.92,0-5.92S388.72,143,392.53,143Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M373.89,187.58c2.08,1.59,12.19-7.74,16.75-18.87,3.79-9.24,4.44-20.93,1.89-21.61s-4.19,15.36-7.25,21.26C381.42,175.81,371.66,185.88,373.89,187.58Z",
    style: {
      fill: "#fff"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Sparkles--inject-45"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "262.63 92.72 269.9 91.38 271.52 83.72 273.14 91.38 280.41 92.73 273.18 94.5 271.52 101.73 269.87 94.5 262.63 92.72",
    style: {
      fill: "#FFC727"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "379.73 220.09 386.99 218.75 388.62 211.09 390.24 218.75 397.51 220.09 390.27 221.86 388.62 229.1 386.96 221.86 379.73 220.09",
    style: {
      fill: "#FFC727"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "283.46 204.02 287.53 203.27 288.44 198.99 289.34 203.27 293.4 204.02 289.36 205.01 288.44 209.05 287.51 205.01 283.46 204.02",
    style: {
      fill: "#FFC727"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "305.57 72.94 309.63 72.19 310.54 67.9 311.44 72.19 315.5 72.94 311.46 73.93 310.54 77.97 309.61 73.93 305.57 72.94",
    style: {
      fill: "#FFC727"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M288.43,224a1.18,1.18,0,0,0,0-2.36A1.18,1.18,0,0,0,288.43,224Z",
    style: {
      fill: "#FFC727"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M403,209.05a.83.83,0,0,0,0-1.66A.83.83,0,0,0,403,209.05Z",
    style: {
      fill: "#FFC727"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M284,100.3a.83.83,0,0,0,0-1.66A.83.83,0,0,0,284,100.3Z",
    style: {
      fill: "#FFC727"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M419.91,113a.84.84,0,0,0,0-1.67A.84.84,0,0,0,419.91,113Z",
    style: {
      fill: "#FFC727"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M409.24,120.63c2.91,0,2.91-4.52,0-4.52S406.33,120.63,409.24,120.63Z",
    style: {
      fill: "#FFC727"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Box--inject-45"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 245.29,
    y: 353.62,
    width: 192.75,
    height: 103.29,
    style: {
      fill: "#FFC727"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 245.29,
    y: 353.62,
    width: 192.75,
    height: 103.29,
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 245.3,
    y: 353.62,
    width: 72.96,
    height: 103.3,
    transform: "translate(563.57 810.54) rotate(180)",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.33,451.1q8.1-11.19,16.06-22.45l15.83-22.57,15.63-22.66q7.77-11.35,15.39-22.78-8.12,11.19-16.07,22.45l-15.82,22.57-15.63,22.66Q258,439.67,250.33,451.1Z",
    style: {
      fill: "#FFC727"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.33,360.64q7.62,11.42,15.39,22.78l15.63,22.66,15.82,22.57q8,11.27,16.07,22.45-7.62-11.43-15.39-22.78l-15.63-22.66-15.83-22.57Q258.44,371.83,250.33,360.64Z",
    style: {
      fill: "#FFC727"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 270.56,
    y: 353.62,
    width: 22.16,
    height: 24.19,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 403.32,
    y: 430.2,
    width: 1.19,
    height: 16.79,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 406.18,
    y: 430.2,
    width: 1.19,
    height: 16.79,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 409.03,
    y: 430.2,
    width: 1.19,
    height: 16.79,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 411.89,
    y: 430.2,
    width: 1.19,
    height: 16.79,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 414.74,
    y: 430.2,
    width: 1.19,
    height: 16.79,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 417.6,
    y: 430.2,
    width: 1.19,
    height: 16.79,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 420.46,
    y: 430.2,
    width: 1.19,
    height: 16.79,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 423.31,
    y: 430.2,
    width: 1.19,
    height: 16.79,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 426.17,
    y: 430.2,
    width: 1.19,
    height: 16.79,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M391.64,445.71l4.58,1.27H385.47l4.58-1.29v-6.17c-3.28-.43-4.58-3.66-4.58-9.32h10.75c0,5.64-1.3,8.89-4.58,9.32Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "382.96 438.76 380.16 438.76 380.16 446.98 372.97 446.98 372.97 438.76 370.15 438.76 376.56 430.2 382.96 438.76",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "438.05 456.92 438.05 446.44 318.27 427.04 318.27 456.91 438.05 456.92",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "223.63 327.79 296.6 327.79 318.27 353.62 245.29 353.62 223.63 327.79",
    style: {
      fill: "#FFC727"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "223.63 327.79 296.6 327.79 318.27 353.62 245.29 353.62 223.63 327.79",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "459.71 327.79 386.74 327.79 365.07 353.62 438.05 353.62 459.71 327.79",
    style: {
      fill: "#FFC727"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "459.71 327.79 386.74 327.79 365.07 353.62 438.05 353.62 459.71 327.79",
    style: {
      opacity: 0.1
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWeInnovate);
export default __webpack_public_path__ + "static/media/weInnovate.a9bc8cef78b3a49808f32f32bc40f63d.svg";
export { ForwardRef as ReactComponent };